<template>
  <main class="order order-flight">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="navsteps navstepts-flight">
            <div class="navsteps__item">
              <div class="number">1</div>
              <div class="descr">Розрахунок</div>
            </div>
            <div class="navsteps__item">
              <div class="number">2</div>
              <div class="descr">Вибір СК</div>
            </div>
            <div class="navsteps__item active">
              <div class="number">3</div>
              <div class="descr">Оформлення</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="orders osago">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <a href="javascript:void(0);" class="go-back" @click="$router.go(-1)">
              Повернутися до вибору
            </a>
            <div class="title company_name">Оформлення страхування від {{
                offerInfo.company.publicName
              }}
            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-auto">
                    <div class="fill-btn-element">
                      <div class="icon">
                        <button @click="fillClientData()" class="btn" style="width: 53px">
                          <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                               xmlns="http://www.w3.org/2000/svg"
                               xmlns:xlink="http://www.w3.org/1999/xlink">
                            <rect width="32" height="32" fill="url(#pattern3)"/>
                            <defs>
                              <pattern id="pattern3"
                                       patternContentUnits="objectBoundingBox" width="1"
                                       height="1">
                                <use xlink:href="#image0_561_1706"
                                     transform="scale(0.01)"/>
                              </pattern>
                              <image id="image0_561_1706" width="100" height="100"
                                     xlink:href="data:image/png;base64,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"/>
                            </defs>
                          </svg>
                        </button>
                      </div>
                      <i class="icon question" data-html="true" data-placement="bottom"
                         data-select="true" data-toggle="tooltip" title="Заповнення форми"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row flex-lg-row-reverse">
              <div class="col-lg-4">
                <div class="sticky-wrapp">
                  <TourismPolicy :dataStep="step" :dataFullPrice="offerInfo.fullPrice || offerInfo.price"/>
                </div>
              </div>

              <form class="col-lg-8 step-block">
                <div class="row">
                  <!--                                    TODO need will finish-->
                  <payer-form
                    ref="payer-form"
                    v-model="payer"
                    :searchInfo="searchInfo"
                    :submitCheck="submitCheck"
                    @showFillClientDataModal="fillClientData"
                    @saveFillData="saveFillData"
                    @selectedPibInn="onSelectedPibIn"
                  ></payer-form>
                  <AddressForm
                    v-model="payer"
                    :submitCheck="submitCheck"
                  />
                  <TouristsForm v-model="TouristsList"
                                :submitCheck="submitCheck"
                                @updatedClientData="getClientDataForUpdating"
                                @payerIsTourist="payerIsTouristFunc"
                                ref="tourists-form"
                  />
                  <div class="row col-lg-12 order-nav">
                    <div class="col-lg-6 text-center">
                      <button type="button" class="btn btn-blue"
                              @click="submitHandler('nextFinal')">
                        Перейти до наступного кроку
                      </button>
                    </div>
                    <div class="col-lg-6 text-center">
                      <button type="button" class="btn btn-outline-secondary"
                              @click="submitHandler('save')">
                        Зберегти чернетку
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <animationModal></animationModal>
    <modalSuccess @dataDraftUrl="getDraftUrl()" @next="submitHandler('nextFinal')"
                  :show-draft-btn="false"></modalSuccess>
    <clients-fill-data-func :show-fill-client-data-modal="showFillClientDataModal" :clien-data="selectedPibInn"
                            :search-info="searchInfo" :offer-info="offerInfo" :product-type="productType"
                            @close="showFillClientDataModal = false" @save="saveFillData"/>
  </main>
</template>
<style scoped lang="scss">
.title.company_name {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<script>
import Multiselect from 'vue-multiselect';
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import {maxLength, minLength, required, requiredIf} from 'vuelidate/lib/validators';
import {getData, saveClient } from '@/api/client';
import {orderTourism} from '@/api/orderTourism';
import ClientsFillDataFunc from '@/components/app/clients/clientsFillDataFunc.vue';
import DocumentsBlock from '@/components/app/forms/DocumentsBlock.vue';
import modalSuccess from '@/components/app/modals/modal-draft-success';
import animationModal from '@/components/app/modals/modal-draftAnimation';
import TourismPolicy from '@/components/app/tourism/TourismPolicy.vue';
import { documentMixin } from '@/mixin';
import { InsuredsListItem } from '@/views/osago/components';
import AddressForm from '@/views/tourism/components/AddressForm.vue';
import PayerForm from '@/views/tourism/components/PayerForm.vue';
import TouristsForm from '@/views/tourism/components/TouristsForm.vue';
import identificationCodePolicy from '@/views/tourism/mixins/identificationCodePolicy';

export default {
  mixins: [documentMixin, identificationCodePolicy],
  components: {
    TouristsForm,
    AddressForm,
    PayerForm,
    ClientsFillDataFunc,
    Multiselect,
    animationModal,
    VueTypeaheadBootstrap,
    modalSuccess,
    InsuredsListItem,
    TourismPolicy,
    DocumentsBlock,
  },
  data: function () {
    return {
      fetchClientsTimeout: null,
      selectedPibInn: false,
      showFillClientDataModal: false,
      isfillData: false,
      clientId: null,
      productType: 'tourism',
      step: 'steps',
      isLoadInsuredsList: false,
      isLoadInsuredsListBySurname: false,
      isLoadInsuredsByCompanyName: false,
      draftUrl: '',
      errors: [],
      TouristsList: [],
      LetterMaskError: false,
      orderId: null,
      searchInfo: null,
      payerIsTourist: false,
      submitCheck: false,
      insuredsList: {},
      insuredsListBySurname: {},
      payer: {
        identificationCode: null,
        withoutDocuments: false,
        name: null,
        surname: null,
        dateBirth: false,
        phone: null,
        mail: null,
        city: null,
        street: null,
        house: null,
        apartment: null,
        documentType: 2,
        passportSerial: null,
        passportNumber: null,
        passportDate: null,
        withoutIdentificationCode: false,
        documentation: {
          //TODO текущее значение нобходимо будет брать с словаря(api)

          type: 2,//'DOCUMENT_EXTERNAL_PASSPORT'
          serial: null,
          number: null,
          issuedBy: null,
          dateOfIssue: null,
          endDateOfIssue: null,
          dateOfIssueError: false,
          documentType: null,
        },
      },
    };
  },
  validations: {
    TouristsList: {
      $each: {
        name: {
          required, minLength: minLength(2), maxLength: maxLength(30),
          onlyLatinCharacters(value) {
            return this.onlyLatinCharactersAndNum(value);
          }
        },
        surname: {
          required: requiredIf(function (nestedModel) {
            return true;
          }), minLength: minLength(2), maxLength: maxLength(30),
          onlyLatinCharacters(value) {
            return this.onlyLatinCharacters(value);
          }
        },
        dateBirth: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(10),
          customMinLength(value) {
            return value !== null && value.length === 10;
          },
          daysInMonth: (value) => {
            if (value === null) {
              return true;
            }

            return (parseInt(moment(value, 'DD.MM.YYYY').format('DD'))) <= moment(value, 'DD.MM.YYYY').daysInMonth();
          },
        },
        identificationCode: {
          // Для СК з правилом за віком (Guardian — від 16 років) ІПН
          // обов'язковий незалежно від галочки «Відсутній ІПН».
          required: requiredIf(function (nestedModel) {
            return this.isInnRequiredByAge(nestedModel.dateBirth) || !nestedModel.withoutIdentificationCode;
          }), customMinLength(value) {
            if (!this.required && (value === null || value === undefined || value === '')) {
              return true;
            }
            return value !== undefined && value !== null && value.length === 10;
          },
          unique(value) {
            const allCodes = this.TouristsList.map((tourist) => tourist.identificationCode);
            const count = allCodes.reduce((acc, code) => {
              if (code === '') {
                return acc;
              }
              acc[code] = (acc[code] || 0) + 1;
              return acc;
            }, {});

            const hasDuplicates = Object.values(count).some((val) => val > 1);
            return !hasDuplicates || false;
          }
        },
        documentType: {},
        passportSerial: { required },
        passportNumber: { required },
        passportDate: {
          required,
          minDateValid(value, vm) {
            const passportDate = moment(value, 'DD.MM.YYYY');
            const birthDate = moment(vm.dateBirth, 'DD.MM.YYYY');

            return passportDate > birthDate;
          }
        },
        passportEndDate: {},
        passportIssuedBy: {},
        withoutIdentificationCode: {}
      }
    },
  },
  created() {
    this.fetchInfo(this.$store.getters.GET_TOURISM_INFO_USER);
    this.searchInfo = this.$store.getters.GET_SEARH_TOURISM_PARAMS;

    if (!this.offerInfo.oldPrice) {
      this.offerInfo.oldPrice = this.offerInfo.price;
      this.offerInfo.price = this.getEtalonPrice();
    } else {
      this.offerInfo.price = this.offerInfo.oldPrice;
      this.offerInfo.price = this.getEtalonPrice();
    }

    this.TouristsList = this.$store.getters.GET_TOURISM_INFO_TOURISTSLIST ?? [];

    this.insuredsListBySurname = { 'payer': [] };
    this.insuredsList = { 'payer': [] };
    if (this.TouristsList.length != this.searchInfo.tourists) {
      this.searchInfo.birthDates.forEach((date, i) => {
        this.TouristsList[i] = this.blankTourist(date);
        this.insuredsListBySurname[i] = [];
        this.insuredsList[i] = [];
      });
    } else {
      this.TouristsList.forEach((tourist, i) => {
        this.TouristsList[i].documentType = this.convertationDocumentType(this.TouristsList[i].documentType);
        // Дати народження беремо з калькуляції: збережений список туристів
        // може бути з попереднього замовлення з іншими датами
        this.TouristsList[i].dateBirth = this.searchInfo.birthDates[i] ?? this.TouristsList[i].dateBirth;
      });
    }

    if (this.$store.getters.GET_TOURISM_FULL_ORDER) {
      this.orderId = this.$store.getters.GET_TOURISM_FULL_ORDER.orderId;
    }

    if (this.$store.getters.GET_CLIENT) {
      this.clientId = this.$store.getters.GET_CLIENT;
    }
  },

  mounted() {
    $('[data-toggle="tooltip"]').tooltip({
      html: true
    });
  },

  computed: {
    offerInfo() {
      return this.$store.getters.GET_TOURISM_INFO_OFFER;
    },
    allowedTouristDocuments() {
      return this.offerInfo?.available_documents ?? this.offerInfo?.allowed_documents ?? null;
    },
    allDocuments() {
      return this.$store.getters.DOCUMENTS_TYPES;
    },
  },
  watch: {
    'payer.name': async function (newValue, oldValue) {
      this.insuredsListBySurname['payer'] = [];
      this.isLoadInsuredsByCompanyName = false;
    },

    'payer.dateBirth': function (newValue, oldValue) {
      delete this.errors['payer.dateBirth'];
      delete this.errors['payer.identificationCode'];
    },
    'payer.identificationCode': async function (newValue, oldValue) {
      if (this.isfillData == true) return;
      if (newValue && newValue.length >= 2) {
        if (this.timer) {
          clearTimeout(this.timer);
          this.timer = null;
        }
        this.timer = setTimeout(async () => {
          if (newValue && newValue.length === 10) {
            this.payer.dateBirth = moment('01.01.1900', 'DD.MM.YYYY')
              .add(newValue.substr(0, 5) - 1, 'day')
              .format('DD.MM.YYYY');
          }
          this.isLoadInsuredsList = true;
          await this.fetchClients(newValue, 'identificationCode');
        }, 800);
      }

      delete this.errors['payer.identificationCode'];
    },
    'payer': {
      handler: function (val, oldVal) {
        this.$store.commit('SET_TOURISM_INFO_USER', this.payer);
      },
      deep: true
    },
  },
  methods: {
    onSelectedPibIn(value) {
      this.selectedPibInn = value;
    },
    updateStore(offerInfo) {
      this.$store.commit('SET_TOURISM_INFO_OFFER', offerInfo);
      this.$store.commit('SET_TOURISM_FULL_ORDER', offerInfo.orderId);
    },
    async fetchClients(query, type) {
      if (!query) {
        this.isLoadInsuredsList = false;
        return;
      }
      this.insuredsList = [];
      let params = {
        'requestType': 'clientsByUserId',
        'searchText': query,
        'customerType': this.orderData?.requestData?.customerType
      };
      clearTimeout(this.fetchClientsTimeout);
      this.fetchClientsTimeout = setTimeout(async () => {
        let response = await getData(params);
        if (type == 'identificationCode') {
          this.insuredsList['payer'] = response.data.data.items;
        } else if (type == 'surname') {
          this.insuredsListBySurname['payer'] = response.data.data.items;
        }
        this.isLoadInsuredsList = false;
        this.isLoadInsuredsListBySurname = false;
      }, 1000);
    },
    getEtalonPrice() {
      return (parseFloat(this.offerInfo.price)).toFixed(2);
    },
    // dateBirth не чіпаємо: дати туристів зафіксовані калькуляцією
    payerIsTouristFunc(event) {
      if (event.target.checked) {
        this.$set(this.TouristsList[0], 'name', this.payer.name);
        this.$set(this.TouristsList[0], 'surname', this.payer.surname);
        this.$set(this.TouristsList[0], 'identificationCode', this.payer.identificationCode);

        this.$set(this.TouristsList[0], 'documentType', this.payer.documentation.type);
        this.$set(this.TouristsList[0], 'passportSerial', this.payer.documentation.serial);
        this.$set(this.TouristsList[0], 'passportNumber', this.payer.documentation.number);
        this.$set(this.TouristsList[0], 'passportDate', this.payer.documentation.dateOfIssue);
        this.$set(this.TouristsList[0], 'passportIssuedBy', this.payer.documentation.issuedBy);
        this.$set(this.TouristsList[0], 'passportEndDate', this.payer.documentation.endDateOfIssue);
        this.$set(this.TouristsList[0], 'withoutIdentificationCode', this.payer.withoutIdentificationCode);
        this.$set(this.TouristsList[0], 'unzr', this.payer.documentation.unzr || null);
        this.$set(this.TouristsList[0], 'city', this.payer.city);
        this.$set(this.TouristsList[0], 'street', this.payer.street);
        this.$set(this.TouristsList[0], 'house', this.payer.house);
        this.$set(this.TouristsList[0], 'apartment', this.payer.apartment);
      } else {
        this.$set(this.TouristsList[0], 'name', '');
        this.$set(this.TouristsList[0], 'surname', '');
        this.$set(this.TouristsList[0], 'identificationCode', '');

        this.$set(this.TouristsList[0], 'documentType', 2);//"DOCUMENT_EXTERNAL_PASSPORT"
        this.$set(this.TouristsList[0], 'passportSerial', '');
        this.$set(this.TouristsList[0], 'passportNumber', '');
        this.$set(this.TouristsList[0], 'passportDate', '');
        this.$set(this.TouristsList[0], 'passportEndDate', '');
        this.$set(this.TouristsList[0], 'passportIssuedBy', '');
        this.$set(this.TouristsList[0], 'withoutIdentificationCode', false);
        this.$set(this.TouristsList[0], 'unzr', null);
        this.$set(this.TouristsList[0], 'city', null);
        this.$set(this.TouristsList[0], 'street', null);
        this.$set(this.TouristsList[0], 'house', null);
        this.$set(this.TouristsList[0], 'apartment', null);
      }
    },
    /**
     * Порожній турист із датою народження з калькуляції: склад і віки
     * туристів зафіксовані розрахунком, тому перерахунку на цьому кроці немає.
     */
    blankTourist(dateBirth) {
      return {
        name: '',
        surname: '',
        dateBirth: dateBirth,
        identificationCode: '',
        passportSerial: '',
        passportNumber: '',
        passportDate: '',
        passportEndDate: '',
        passportIssuedBy: '',
        withoutIdentificationCode: false,
        documentType: 2, // DOCUMENT_EXTERNAL_PASSPORT
        city: null,
        street: null,
        house: null,
        apartment: null,
      };
    },
    async submitHandler(type) {
      //TODO need refactoring
      if (this.errors['tourist.errorBirthDate'] && this.errors['tourist.errorBirthDate'].length > 0) {
        const el = document.querySelector('.invalid:first-of-type');
        const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: y, behavior: 'smooth' });
        return;
      }
      if (this.errorBirthDate()) {
        return;
      }
      this.submitCheck = true;
      const balance = this.$store.getters.ALL_TRANSACTIONS.amount - this.$store.getters.ALL_TRANSACTIONS.creditLimit;
      if (balance < this.offerInfo.fullPrice && type !== 'save') {
        this.$alert('Підписання договору неможливо, недостатньо коштів на рахунку', '', 'error');
        return;
      }

      if (this.$refs['payer-form'].$v.$invalid) {
        this.$refs['payer-form'].$v.$touch();
        this.$nextTick(() => {
          const el = document.querySelector('.invalid:first-of-type');
          const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });

        return;
      }
      if (this.$refs['payer-form'].$refs['documents-block'].$v.$invalid) {
        this.$refs['payer-form'].$refs['documents-block'].$v.$touch();
        this.$nextTick(() => {
          const el = document.querySelector('.invalid:first-of-type');
          const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });

        return;
      }

      if (this.$refs['tourists-form'].$v.$invalid) {
        this.$refs['tourists-form'].$v.$touch();
        this.$nextTick(() => {
          const el = document.querySelector('.invalid:first-of-type');
          const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });

        return;
      }

      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$nextTick(() => {
          const el = document.querySelector('.invalid:first-of-type');
          const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        });

        return;
      }

      let offerInfo = Object.assign({}, this.offerInfo);
      let searchInfo = this.searchInfo;
      offerInfo.allowed_documents = this.offerInfo.available_documents ?? this.offerInfo.allowed_documents;
      let userInfo = Object.assign({}, this.payer);

      let TouristsListInfo = this.TouristsList;

      let params = {
        type: type,
        statusId: 1, //на этом этапе у нас только черновик возможен
      };

      if (['save', 'nextFinal'].includes(type)) {
        this.showAnimateModal();
      }
      offerInfo.orderId = this.orderId;

      let discountDetails = {
        dynamicDiscountPrice: 0,
        dynamicDiscountPercent: 0,
        dynamicDiscountedSum: 0,
        dynamicEarnings: 0
      };

      if (this.offerInfo.dynamicDiscountPrice > 0) {
        discountDetails.dynamicDiscountPrice = +parseFloat(offerInfo.dynamicDiscountPrice).toFixed(2);
        discountDetails.dynamicDiscountPercent = +parseFloat(offerInfo.dynamicDiscountPercent).toFixed(2);
        discountDetails.dynamicDiscountedSum = +parseFloat(offerInfo.dynamicDiscountedSum).toFixed(2);
        discountDetails.dynamicEarnings = +parseFloat(offerInfo.dynamicEarnings).toFixed(2);
        discountDetails.earnings = +parseFloat(offerInfo.earnings).toFixed(2);

        offerInfo.discountDetails = discountDetails;
        offerInfo = { ...offerInfo, ...discountDetails };
      } else {
        offerInfo.discountDetails = null;
        offerInfo = { ...offerInfo, ...discountDetails };
      }

      this.updateStore(offerInfo);

      this.$store.commit('SET_TOURISM_INFO_USER', userInfo);
      this.$store.commit('SET_TOURISM_INFO_TOURISTSLIST', TouristsListInfo);
      this.getClientDataForUpdating();
      orderTourism(offerInfo, searchInfo, userInfo, TouristsListInfo, this.orderId, params).then((response) => {
        $('#modalPayAnimation').modal('hide');
        if (response?.data?.status === 'sanctioned' || response?.data?.data[0]?.status == 'sanctioned') {
          this.$alert(
            `<div class="sanctions-alert-content">
                             <p>Данного клієнта знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                             <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                             <p><strong>Дата народження:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                             <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                             <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                           </div>`,
            'Санкції!',
            {
              dangerouslyUseHTMLString: true,
              type: 'error',
              customClass: 'sanctions-alert'
            }
          );
          return false;
        }
        if (response?.data?.data[0]?.status == 'possible_match') {
          this.$alert(
            `<div class="sanctions-alert-content">
                             <p>Данного клієнта вірогідно знайдено у санкційних списках, заборонено оформлення полісу. Зверніться у підтримку якщо сталась помилка</p>
                             <p><strong>Ім'я:</strong> ${response?.data?.data[0]?.message?.name || response?.data?.data[0]?.message[0]?.name || 'Немає даних'}</p>
                             <p><strong>Дата народження:</strong> ${response?.data?.data[0]?.message?.birthdate || response?.data?.data[0]?.message[0]?.birthdate || 'Немає даних'}</p>
                             <p><strong>Документи:</strong> ${response?.data?.data[0]?.message?.identity_docs || response?.data?.data[0]?.message[0]?.identity_docs || 'Немає даних'}</p>
                             <p><strong>Санкції:</strong> ${response?.data?.data[0]?.message?.sanctions || response?.data?.data[0]?.message[0]?.sanctions || 'Немає даних'}</p>
                           </div>`,
            'Санкції!',
            {
              dangerouslyUseHTMLString: true,
              type: 'error',
              customClass: 'sanctions-alert'
            }
          );
          return false;
        }

        if (response?.data?.errorInfo?.errorType === 'price-changed') {
          this.changePrice(response.data.errorInfo.newPrice);
          return;
        }this.orderId = response?.data?.data[0]?.id;
        offerInfo.orderId = this.orderId;

        this.updateStore(offerInfo);

        if (type == 'save') {
          $('#modalPayAnimation').modal('hide');
          this.draftUrl = response.data?.data[1]?.contractDraft_path;
          $('#modalFlightSuccess').modal('show');
          return;
        }

        if (type === 'nextFinal') {
          if (this.orderId) {this.$router.push({name: 'tourismFinnaly'});
        } else {
          $('#modalPayAnimation').modal('hide');
          this.$alert('Помилка створення замовлення. Спробуйте ще раз.', '', 'error');
          }
        } else {
          $('#modalPayAnimation').modal('hide');
          this.$alert('Чернетка успішно збережена.');
        }
      }).catch((error) => {$('#modalPayAnimation').modal('hide');
        if (error?.response?.data?.message) {

          let messages = Object.keys(error.response.data.data|| {}).map(key => {
            return error.response.data.data[key].toString();
          }).toString();
          if (messages == '[object Object]') {
            try {const parsedMessage = JSON.parse(error?.response?.data?.message);
            if (parsedMessage && parsedMessage.ModelState) {
              let errorMessage = [];
              for (const key in parsedMessage.ModelState) {
                parsedMessage.ModelState[key].forEach(msg => {
                  errorMessage.push(`${msg}`);
                });
              }
              this.$alert(errorMessage.join(' | '), '', 'error');
            } else {
              this.$alert('Відповідь від модуля страхової компанії: ' + error?.response?.data?.message, '', 'error');
              }
            } catch(e) {
              this.$alert('Відповідь від модуля страхової компанії: ' +error?.response?.data?.message, '', 'error');
            }
          } else {
            this.$alert(messages|| error?.response?.data?.message || 'Щось пішло не так. Спробуйте ще раз.', '', 'error');
          }
        }else {
          this.$alert('Щось пішло не так. Спробуйте ще раз.', '', 'error');
        }
      });
    },
    changePrice(newPrice) {
      let updatedOffer = { ...this.offerInfo };
      updatedOffer.price = newPrice;
      updatedOffer.fullPrice = newPrice;
      updatedOffer.oldPrice = newPrice;
      this.updateStore(updatedOffer);
      $('#modalPayAnimation').modal('hide');
      this.$alert(
        `Ціна полісу змінилась. Оновлена ціна: ${newPrice} грн. Натисніть "Перейти до наступного кроку" для підтвердження.`,
        '',
        'warning'
      );
    },
    getDraftUrl() {
      window.open(`/api/orders/draft/${this.$store.getters.USER.id}/${this.orderId}`);
    },
    showAnimateModal() {
      $('#modalPayAnimation').modal({
        backdrop: 'static',
        keyboard: true,
        show: true,
      });

      let width = 1;
      let id = setInterval(frame, 200);

      /**
       *
       */function frame() {
        if (width >= 99) {
          clearInterval(id);
          // i = 0;
        } else {
          width += 2;
          $('.results_anime_percent-text').text(`${width}%`);
          $('.results_anime_line-scale').css({width: `${width}%`});
        }
      }
    },
    fetchInfo(data) {
      if (data) {
        this.payer = data;
        this.payer.documentation.type = this.convertationDocumentType(this.payer.documentation.type) ?? data.documentType;
      }
    },
    errorBirthDate: function () {
      if (this.payer.dateBirth == '' || this.payer.dateBirth == null || this.payer.dateBirth == '') {
        return false;
      }
      if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) < 18) {
        this.errors['payer.errorBirthDate'] = ['Страхувальнику повинно бути більше 18 років'];

        return true;
      } else if ((parseInt(moment(this.payer.dateBirth, 'DD.MM.YYYY').diff(moment(), 'years') - 1) * -1) > 100) {
        this.errors['payer.errorBirthDate'] = ['Страхувальнику повинно бути не більше 100 років'];

        return true;
      } else {
        delete this.errors['payer.errorBirthDate'];
      }
      return false;
    },
    hasError(name, index = false) {
      if (!index) {
        return this.errors[name] !== undefined;
      } else {
        if (this.errors[name]) {
          return this.errors[name][index] !== undefined;
        } else return false;
      }
    },
    convertationDocumentType(DocumentType) {
      return this.convertDocumentToNumber(DocumentType);
    },
    getError(name) {
      if (this.hasError(name)) {
        return this.errors[name][0].replace(name, '');
      }
      return [];
    },
    onlyLatinCharacters(str) {
      if (str == null || str == '') return true;
      return /^[a-zA-Z\- ]+$/.test(str);
    },
    onlyLatinCharactersAndNum(str) {
      if (str == undefined || str == null || str == '') return true;
      return /^[a-zA-Z0-9 ]+$/.test(str);
    },
    fillClientData() {
      this.showFillClientDataModal = true;
    },
    saveFillData(params) {
      this.showFillClientDataModal = false;
      this.fillFormFromClientData(params.selectPibInn, params.selectTourists, params.selectDocument);
    },
    async fillFormFromClientData(selectPibInn, selectTourists, selectDocument) {
      this.clientId = selectPibInn.id;
      this.$store.commit('SET_CLIENT', selectPibInn.id);
      let fio_en = selectPibInn.fio_en.split(' ');

      this.payer.surname = fio_en[0];
      this.payer.name = fio_en[1];

      this.payer.phone = selectPibInn.phone;
      this.payer.mail = selectPibInn.email;

      this.payer.dateBirth = (selectPibInn.date_of_birth) ? moment(selectPibInn.date_of_birth, 'DD-MM-YYYY').format('DD.MM.YYYY') : null;

      if (selectDocument) {
        this.payer.documentation.type = selectDocument.document_type;
        this.payer.documentation.serial = selectDocument.serial;
        this.payer.documentation.number = selectDocument.number;
        this.payer.documentation.issuedBy = selectDocument.issued_by;
        this.payer.documentation.dateOfIssue = (selectDocument.date_of_issue) ? moment(selectDocument.date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
        this.payer.documentation.endDateOfIssue = (selectDocument.end_date_of_issue) ? moment(selectDocument.end_date_of_issue, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;

      }

      this.payer.street = selectPibInn.street;
      this.payer.house = selectPibInn.house;
      this.payer.city = selectPibInn.city;
      this.payer.identificationCode = selectPibInn.identification_number;
      this.payer.withoutIdentificationCode = (selectPibInn.identification_number) ? false : true;
      this.payer.apartment = selectPibInn.flat;

      if (selectTourists) {
        // Склад туристів зафіксований калькуляцією: збережених підставляємо
        // лише в межах розрахованої кількості, решту слотів лишаємо порожніми
        const calcBirthDates = this.searchInfo.birthDates;
        this.TouristsList = [];
        selectTourists.slice(0, calcBirthDates.length).forEach((person, i) => {
          let dateBirth = (person.date_of_birth) ? moment(person.date_of_birth, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
          let passport_end_date = (person.passport_end_date) ? moment(person.passport_end_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;
          let passport_date = (person.passport_date) ? moment(person.passport_date, 'YYYY-MM-DD').format('DD.MM.YYYY') : null;

          this.TouristsList[i] = {
            name: person.first_name,
            surname: person.last_name,
            // дата народження зафіксована з калькуляції
            dateBirth: this.searchInfo.birthDates[i] ?? dateBirth,
            identificationCode: person.identification_number,
            passportSerial: person.passport_serial,
            passportNumber: person.passport_number,
            passportDate: passport_date,
            passportEndDate: passport_end_date,
            passportIssuedBy: person.passport_issued_by,
            withoutIdentificationCode: (person.identification_number) ? false : true,
            documentType: person.document_type,
            unzr: person.unzr || null,
            city: person.city || null,
            house: person.house ||null,
            street: person.street ||null,
            apartment: person.apartment || null,
          };
          this.insuredsListBySurname[i] = [];
          this.insuredsList[i] = [];
        });
        for (let i = this.TouristsList.length; i < calcBirthDates.length; i++) {
          this.TouristsList[i] = this.blankTourist(calcBirthDates[i]);
          this.insuredsListBySurname[i] = [];
          this.insuredsList[i] = [];
        }

        this.$store.commit('SET_TOURISM_INFO_OFFER', this.offerInfo);
        this.$store.commit('SET_SEARCH_TOURISM_PARAMS', this.searchInfo);
      }
    },
    getOrderData() {
      let filteredTouristsList = this.TouristsList.filter(tourist => tourist.identificationCode && tourist.identificationCode.length === 10);

      return {
        orderId: this.orderId,
        clientId: this.clientId,
        productType: this.productType,
        offerId: this.offerInfo.offerId,
        orderDraft: this.offerInfo?.orderDraft,
        price: this.offerInfo.price,
        fullPrice: this.offerInfo.fullPrice,
        countryId: this.searchInfo.country.id,
        startDate: this.searchInfo.date,
        endDate: this.searchInfo.end,
        periodOption: this.searchInfo.periodOption,
        yearProgram: this.searchInfo.yearProgram,
        allowedDocuments: this.offerInfo.allowed_documents,
        info: {
          identificationCode: this.payer.identificationCode,
          withoutIdentificationCode: this.payer.withoutIdentificationCode,
          name: this.payer.name,
          surname: this.payer.surname,
          dateBirth: this.payer.dateBirth,
          phone: (this.payer.phone == '+38 (0') ? '' : this.payer.phone,
          mail: this.payer.mail,
          city: this.payer.city,
          street: this.payer.street,
          house: this.payer.house,
          apartment: this.payer.apartment,
          documentation: this.payer.documentation,
          documentType: this.payer.documentType,
          passportSerial: this.payer.passportSerial,
          passportNumber: this.payer.passportNumber,
          passportDate: this.payer.passportDate,
        },
        touristsListInfo: filteredTouristsList,
        offerInfo: this.offerInfo,
        searchInfo: this.searchInfo
      };
    },
    getClientDataForUpdating() {
      if (this.isfillData == false) {
        let orderData = this.getOrderData();
        this.updateClientData(orderData);
      }
    },
    updateClientData(orderData) {
      if (
        (this.payer.identificationCode && this.payer.identificationCode.length === 10) ||
        (((this.payer.phone !== null && this.payer.phone !== '+38 (0' && this.payer.phone.length === 19) ||
            (this.payer.mail !== null && this.payer.mail !== '' && !this.$v.payer.mail.$invalid))
          && this.payer.surname !== null && this.payer.name !== null)
      ) {
        orderData = (orderData instanceof Event || !orderData) ? this.getOrderData() : orderData;

        if (orderData) {
          saveClient(orderData).then(response => {
            if (response?.data?.status == 'success') {
              this.clientId = response?.data?.data?.id;
              this.$store.commit('SET_CLIENT', this.clientId);

              this.$store.commit('SET_TOURISM_FULL_ORDER', this.orderId);
            }
          });
        }
      }
    },
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.order-flight .surname-block {
  position: relative;
}

.sanctions-alert .el-message-box__message {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 10px;
}

.passport-row {
  .invalid {
    border-color: #dc3545 !important;
  }
}
</style>
